<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import { PRESENTER_VALUE_FALLBACK } from '@satellite/components/elements/presenters/presenterValueFallback';

const { t } = useI18n();

defineProps<{
  isCheckMode: boolean;
  spotCode: string | null;
  areaName: string | null;
  companyName: string | null;
  isHooked: boolean;
  isBlocked: boolean;
}>();

const emit = defineEmits<{ 'change-location': [] }>();
</script>

<template>
  <div class="d-flex flex-grow-0 border-b border-color-line-border bg--color-neutral-0">
    <button
      v-ripple="!isBlocked"
      type="button"
      class="flex-fill d-flex align-center justify-space-between gap-2 pa-4 check-asset-panel__location-btn"
      :class="{ 'opacity-50': isBlocked }"
      :disabled="isBlocked"
      data-testid="check-asset-panel-location-btn"
      @click="emit('change-location')">
      <div class="d-flex align-center gap-2 min-w-0">
        <v-icon
          size="20"
          class="flex-shrink-0"
          :class="spotCode ? 'text-high-emphasis' : 'text--color-text-tertiary'"
          :icon="spotCode ? 'mdi-map-marker-outline' : 'mdi-map-marker-off-outline'" />
        <div class="d-flex flex-column min-w-0">
          <template v-if="spotCode">
            <span v-if="areaName" class="typography-body-md text-medium-emphasis text-truncate">
              {{ areaName }}
            </span>
            <span class="typography-body-md-bold text-high-emphasis text-truncate">
              {{ spotCode }}
            </span>
          </template>
          <span v-else class="typography-body-md text--color-text-tertiary text-truncate">
            {{ t('checkTaskDetails.card.unassignedLocation') }}
          </span>
        </div>
      </div>
      <v-icon
        v-if="!isBlocked"
        size="20"
        class="flex-shrink-0 text-medium-emphasis"
        icon="mdi-swap-horizontal" />
    </button>

    <v-divider vertical />

    <div class="flex-fill d-flex align-center justify-center gap-2 pa-4">
      <template v-if="isHooked">
        <v-icon size="20" class="flex-shrink-0 text-high-emphasis" icon="mdi-link-variant" />
        <span class="typography-body-md text-high-emphasis text-truncate">
          {{ companyName ?? PRESENTER_VALUE_FALLBACK }}
        </span>
      </template>
      <template v-else>
        <v-icon size="20" class="flex-shrink-0 text-medium-emphasis" icon="mdi-hook-off" />
        <span class="typography-body-md text-medium-emphasis text-truncate">
          {{ t('checkAssetPanel.unhooked') }}
        </span>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.check-asset-panel__location-btn {
  appearance: none;
  border: none;
  cursor: pointer;
  text-align: start;
  position: relative;
  overflow: hidden;
  transition: background-color 120ms ease;

  &:hover {
    background: rgb(var(--v-theme-neutral-10));
  }
}
</style>
